module.exports = __webpack_public_path__ + "img/icon_texture_selected.43b81b23.png";